import React, { useEffect, useMemo, useState } from "react";
import { Column } from "primereact/column";
import { useTranslation } from "react-i18next";
import func from "../../../services/functions";
import editor, { BodyWrapper } from "../../PrimeTable/helper";
import moment from "moment";
import { toast } from "react-toastify";
import { DataTable } from "primereact/datatable";
import { defaultPayroll, mapSalrayEmployee, payrollDescription } from "./PayrollUtils";
import { bankStatusEmployeeStyle, loadOptionsForBankAccounts } from "../OpenBankingUtils";
import mainAxios from "../../../services/mainAxios";
import currencies from "../../../services/currencies.json"
import ImportEmployees from "./ImportEmployees";
import { faFileImport } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PayrollSummary = ({valid,payroll,setPayroll,validationErrors={},setValidationErrors,disabled}) => {
  const { t } = useTranslation("translations");
  const defaultEmployee=useMemo(()=>({...defaultPayroll.salaryRecords[0]}),[moment])
  const [employeeSuggestions,setEmployeeSuggestions]=useState([])
  const [importDialogVisible, setImportDialogVisible] = useState(false);
  const addEmployee= ({newEmployee,cellOptions})=>{
    setPayroll(payroll=>{
        let salaryRecords = [...payroll.salaryRecords]
        salaryRecords= salaryRecords.map((oldEmployee,index)=>{
          if(index == cellOptions.rowIndex){
            return mapSalrayEmployee(newEmployee,{...defaultPayroll.salaryRecords[0],description:oldEmployee?.description??""})
          }
          return oldEmployee
        })
        const content={
          ...payroll,
          salaryRecords
        }
        valid({validateOnlyEmployeesFields:true,excludeFields:["salaryRecords.amount"],updatedPayroll:content})
        return content
    })
  }
  const [bankList, setBankList] = useState([])  ;
  useEffect(()=> {
    mainAxios
    .get("/api/financialInstitutions")
    .then( res=>{
      if(res.status==200){
        const banks = (res?.data ?? []).map(bank=>{return {label:bank.name,value:bank}});
        setBankList(banks);
      }
    })
  },[])

  const handleImportEmployees = (importedEmployees) => {
    setPayroll((payroll) => {
      const mappedEmployees = importedEmployees.map((emp) => {
        let financialInstitution = null;

        if (emp.connectionAccount?.financialInstitution?.bic) {
          const matchingBank = bankList.find(
            (bank) => {
              const bankBic = bank.value?.bic
              const empBic = emp.connectionAccount.financialInstitution.bic;
              return bankBic && empBic && bankBic.toUpperCase() === empBic.toUpperCase();
            }
          );
          if (matchingBank) {
            financialInstitution = matchingBank.value;
          }
        }

        return {
          ...defaultEmployee,
          employeeFullName: emp.employeeFullName || "",
          connectionAccount: financialInstitution ? {
            financialInstitution: financialInstitution,
            iban: emp.iban || "",
            currency: emp.currency || "ALL",
          } : null,
          iban: emp.iban || "",
          amount: emp.amount || 0,
          currency: emp.currency || "ALL",
          description: emp.description || `Pagese paga ${moment(payroll.period,"MM/YYYY").locale("sq").format("MMMM YYYY")}`,
        };
      });

      return {
        ...payroll,
        salaryRecords: mappedEmployees,
      };
    });
  };
const loadEmployees=async (searchQuery)=>{
  const _suggestions =await loadOptionsForBankAccounts(searchQuery,"EMPLOYEE")
  setEmployeeSuggestions(_suggestions)
}
const summaryEmployeeCols = [
    {
    field: "employeeFullName",
    header: t("payRoll.employeeName"),
    style: {minWidth:"160px",maxWidth:"180px"},
    body:(item,options)=><BodyWrapper parentKey={"salaryRecords"} validate={true} item={item} options={options} errors={validationErrors}>{ item?.employeeFullName ?? ""}</BodyWrapper>,
    cellConfig:{
      type:"AUTOCOMPLETE",
      loadOptions:(searchQuery)=>loadEmployees(searchQuery),
      suggestions:employeeSuggestions,
      onSelect:({e,cellOptions})=>addEmployee({newEmployee:e.value,cellOptions}),
    },
  },
  {
    header: t("payRoll.financialInstitution"),
    field: "connectionAccount.financialInstitution",
    style: {minWidth:"200px",maxWidth:"220px"},
    cellConfig:{
      type:"DROPDOWN",
      options:bankList,
    },
    body:(item,options)=><BodyWrapper disabled={disabled} parentKey={"salaryRecords"}  validate={true} item={item} options={options} errors={validationErrors}>{item?.connectionAccount?.financialInstitution?.name}</BodyWrapper>
  },
  {
    field: "iban",
    header: t("payRoll.iban"),
    style: {minWidth:"200px",maxWidth:"230px"},
    body:(item,options)=><BodyWrapper disabled={disabled} parentKey={"salaryRecords"} validate={true} item={item} options={options} errors={validationErrors}>{ item?.iban ?? ""}</BodyWrapper>,
    hasEditor:true
  },
  {
    field: "amount",
    header: t("payRoll.amount"),
    style: {minWidth:"150px",maxWidth:"170px"},
    body:(item,options)=><BodyWrapper disabled={disabled} parentKey={"salaryRecords"} validate={true} item={item} options={options} errors={validationErrors}>{ item.amount ? func.getFormattedMoneyValue(item.amount) : 0}</BodyWrapper>,
    default:true,
    align:"right",
    cellConfig:{
        type: "number",
    }
  },
  {
    field: "description",
    header: t("payRoll.description"),
    style: {minWidth:"240px",maxWidth:"250px"},
    body:(item,options)=><BodyWrapper disabled={disabled} parentKey={"salaryRecords"} validate={true} item={item} options={options} errors={validationErrors}>{ item?.description ?? ""}</BodyWrapper>,
    default:true,
    hasEditor:true
  },
  {
    field: "currency",
    header: t("payRoll.currency"),
    style: {minWidth:"100px",maxWidth:"120px"},
    cellConfig:{
      type:"DROPDOWN",
      options:currencies,
    },
    body:(item,options)=><BodyWrapper disabled={disabled} parentKey={"accounts"} validate={true} item={item} options={options} errors={validationErrors}>{item.currency}</BodyWrapper>
  },
  {
    field: "salaryRecords.bankStatusDisplayName",
    body: (payroll) => {
      const bankStatusEmployee = bankStatusEmployeeStyle(payroll?.bankStatusDisplayName, t);
      if (!bankStatusEmployee) {
        return null;
      }
      return (
        <h4 className="mb-0">
          <small className={`badge badge-${bankStatusEmployee.badgeClass} ml-2`}>
            {bankStatusEmployee.status}
          </small>                    
        </h4>
      );
    },
    header: t("payRoll.bankStatus"),
    style: {minWidth: "150px", maxWidth: "170px"},
  },
  {
    field: "bankReferenceNumber",
    header: t("payRoll.transactionId"),
    style: {minWidth:"150px",maxWidth:"170px"},
  },
  {
    field: "bankPaymentDate", 
    body: (payroll) => { 
      return payroll?.bankPaymentDate ? moment(payroll?.bankPaymentDate).format("DD/MM/YYYY") : "";
    },
    header: t("payRoll.transactionDate"),
    style: {minWidth:"150px",maxWidth:"170px"},
  },
];
  const addNewItem = (e) => {
    if (e) {
      e.preventDefault();
    }
    if (!valid({validateOnlyEmployeesFields:true})) {
      toast.error(t("payRoll.fixValidations"),{
        containerId: "all_toast",
      });
      return;
    }
    setPayroll((payroll)=>{ 
      return {
        ...payroll,
        salaryRecords:[...(payroll.salaryRecords?? []),{...defaultEmployee,description:`Pagese paga ${moment(payroll.period,"MM/YYYY").locale("sq").format("MMMM YYYY")}`}]
      }
    })
  };
  
  const removeItem = (e, item, index) => {
    e.preventDefault();
    if(index==0 && (payroll.salaryRecords??[]).length==1){
      setPayroll((order)=>({...order,salaryRecords:[...defaultPayroll.salaryRecords]}))
    }else{
      setPayroll((payroll) => {
        const newEmployees = (payroll.salaryRecords ?? []).filter((emp, i) => i !== index);
        return {
        ...payroll,
        salaryRecords: newEmployees,
      }});
    }
  };
    const removeItemColumn = (
      <Column
        body={(...props) => {
          const rowIndex = props?.[1]?.rowIndex;
          return (
            <div className="d-flex justify-content-between ">
              <div>
                  <i
                    onClick={(e) => removeItem(e, payroll.salaryRecords[rowIndex], rowIndex)} 
                    className="pi pi-trash trash"
                  ></i>
              </div>
            </div>
          );
        }}
        headerStyle={{ width: "50px", minWidth: "50px" }}
        bodyStyle={{
          textAlign: payroll?.salaryRecords?.length > 1 ? "center" : "left",
          width: "50px"
        }}
        alignFrozen="right"
        frozen={true}
      />
    );
  
    const addRows = (
      <Column
        body={(...props) => {
          const rowIndex = props?.[1]?.rowIndex;
          return (
            <div className="d-flex justify-content-between">
              <div>
                {rowIndex === payroll?.salaryRecords.length - 1 ? (
                  <i
                    className="pi pi-plus-circle plus"
                    onClick={() => {
                      addNewItem();
                    }}
                  ></i>
                ) : null}
              </div>
            </div>
          );
        }}
        headerStyle={{ width: "50px", minWidth: "50px" }}
        bodyStyle={{
          textAlign: payroll?.salaryRecords?.length > 1 ? "center" : "left",
          width: "50px"
        }}
        alignFrozen="right"
        frozen={true}
      />
    );
  
  
  const handleEmployeesChange = ({ cellOptions, key, value, length,unitDefault=false }) => {
        const index = cellOptions?.rowIndex ?? 0;
        if (index < 0) return;
        value = length != undefined ? value.slice(0, length) : value;
        const keys=key?.split(".")
        setPayroll((payroll) => {
          const content = {
            ...payroll,
            salaryRecords: [
              ...payroll.salaryRecords.map((oldEmployee, oldIndex) =>{
                if(oldIndex !== index){
                  return oldEmployee
                }
                  let newEmp
                  if(keys.length==1){
                    newEmp={
                    ...oldEmployee,
                    [keys[0]]: value
                    } 
                  }else if(keys.length==2){
                   newEmp={
                    ...oldEmployee,
                    [keys[0]]: {
                      ...(oldEmployee[keys[0]] ? {...oldEmployee[keys[0]]}:{}),
                      [keys[1]]: value,
                    },
                  }
                  }
                   return newEmp
              }
                
              ),
            ],
          }
          return content
        });
        return value;
      };
      
 const dynamicColumns = useMemo(()=>summaryEmployeeCols.map((col, i) => {
    const colProps = {
      menu:false,
      sortable:false,
      filter: false,
      showFilterMenu: false,
      ...col,
    };
    if ((colProps?.hasEditor || colProps?.cellConfig) && !disabled) {
      colProps.editor = (options) => editor({parentKey:"salaryRecords", col,disabled, t,cellOptions: options,onChange: ({ key, value, cellOptions }) =>handleEmployeesChange({key, value, cellOptions }),setValidationErrors,validationErrors });
    }
      return <Column key={colProps.field} {...colProps} />;
  }),[handleEmployeesChange,summaryEmployeeCols,payroll?.salaryRecords,editor,disabled]);
    return (
        <>
        {!disabled && (
          <div className="mb-3">
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              onClick={() => setImportDialogVisible(true)}
            >
              <FontAwesomeIcon icon={faFileImport} className="mr-2" />
              {t("payRoll.importEmployees") || "Import Employees"}
            </button>
          </div>
        )}

        <div className="my-2 w-full">
          <DataTable
            scrollable
            scrollHeight="400px"
            editMode="cell"
            resizableColumns
            columnResizeMode="expand"  
            responsiveLayout="scroll"
            size="small"
            inline
            stripedRows
            item
            selectionMode="single"
            value={payroll?.salaryRecords ?? []}
            style={{ width: '100%' }}
          >
            { dynamicColumns }
            { !disabled && addRows }
            { !disabled && removeItemColumn }
    
          </DataTable>
        </div>

        <ImportEmployees
          visible={importDialogVisible}
          onHide={() => setImportDialogVisible(false)}
          onImport={handleImportEmployees}
        />
        </>
    )
};
export default PayrollSummary;